import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { Button } from 'antd';
import { DocumentsUpload } from './DocumentsUpload';
import { IDocument, UploadedFile } from '@rasayi-workspace/shared';

interface DocumentsProp {
    onClose: () => void;
    onSaveDocumenst: (data: any) => void;
    saveData: (data: any) => void;
    initialValue?: IDocument;
    isLoading: boolean;
    leadId: string;
    resetDocuments: React.MutableRefObject<boolean>;
}

export const DocumentsTab: React.FC<DocumentsProp> = ({ onClose, onSaveDocumenst, saveData, initialValue, isLoading, leadId, resetDocuments }) => {
    const isFirstRender = useRef(true);

    const [uploadingProfilePic, setUploadingProfilePic] = useState<UploadedFile[]>([]);
    const [uploadingCnic, setUploadingCnic] = useState<UploadedFile[]>([]);
    const [uploadingBankStatments, setUploadingBankStatments] = useState<UploadedFile[]>([]);
    const [uploadingUtilityBills, setUploadingUtilityBills] = useState<UploadedFile[]>([]);
    const [uploadingSalarySlip, setUploadingSalarySlip] = useState<UploadedFile[]>([]);
    const [uploadingCheque, setUploadingCheque] = useState<UploadedFile[]>([]);
    const [uploadingOthers, setUploadingOthers] = useState<UploadedFile[]>([]);

    const handleSave = () => {
        onSaveDocumenst({ documents: { uploadingProfilePic, uploadingCnic, uploadingBankStatments, uploadingUtilityBills, uploadingSalarySlip, uploadingCheque, uploadingOthers } });
    };

    useEffect(() => {
        saveData({
            profile_pic: uploadingProfilePic,
            cnic: uploadingCnic,
            bank_statement: uploadingBankStatments,
            bills: uploadingUtilityBills,
            salary_slip: uploadingSalarySlip,
            cheque: uploadingCheque,
            others: uploadingOthers,
        });
    }, [
        uploadingProfilePic?.length,
        uploadingCnic?.length,
        uploadingBankStatments?.length,
        uploadingUtilityBills?.length,
        uploadingSalarySlip?.length,
        uploadingCheque?.length,
        uploadingOthers?.length,
    ]);

    useEffect(() => {
        if (isFirstRender.current && initialValue && Object.keys(initialValue).length) {
            setUploadingProfilePic(initialValue.profile_pic);
            setUploadingCnic(initialValue.cnic);
            setUploadingBankStatments(initialValue.bank_statment);
            setUploadingUtilityBills(initialValue.bills);
            setUploadingSalarySlip(initialValue.salary_slip);
            setUploadingCheque(initialValue.cheque);
            setUploadingOthers(initialValue.other);
            isFirstRender.current = false;
        }
    }, [initialValue]);

    const reset = () => {
        setUploadingProfilePic([]);
        setUploadingCnic([]);
        setUploadingBankStatments([]);
        setUploadingUtilityBills([]);
        setUploadingSalarySlip([]);
        setUploadingCheque([]);
        setUploadingOthers([]);
        isFirstRender.current = true;
        resetDocuments.current = false;
    };
    useEffect(() => {
        if (resetDocuments.current) {
            reset();
        }
    }, [resetDocuments]);


    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: '100%' }}>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '16px',
                    maxWidth: '100%',
                    overflowX: 'hidden',
                }}
            >
                <DocumentsUpload title="Profile Picture" maxFiles={3} uploadFiles={setUploadingProfilePic} uploadedFiles={uploadingProfilePic} leadId={leadId} />
                <DocumentsUpload required={true} title="CNIC" maxFiles={3} uploadFiles={setUploadingCnic} uploadedFiles={uploadingCnic} leadId={leadId} />
                <DocumentsUpload title="Bank Statement" maxFiles={3} uploadFiles={setUploadingBankStatments} uploadedFiles={uploadingBankStatments} leadId={leadId} />
                <DocumentsUpload title="Utility Bills" maxFiles={3} uploadFiles={setUploadingUtilityBills} uploadedFiles={uploadingUtilityBills} leadId={leadId} />
                <DocumentsUpload title="Salary Slip" maxFiles={3} uploadFiles={setUploadingSalarySlip} uploadedFiles={uploadingSalarySlip} leadId={leadId} />
                <DocumentsUpload title="Cheque" maxFiles={3} uploadFiles={setUploadingCheque} uploadedFiles={uploadingCheque} leadId={leadId} />
                <div style={{ gridColumn: 'span 3' }}>
                    <DocumentsUpload title="Other" maxFiles={11} uploadFiles={setUploadingOthers} uploadedFiles={uploadingOthers} leadId={leadId} />
                </div>
            </div>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                <Button onClick={onClose} className="mr-2 text-red-700 border-red-700 bg-white hover:bg-red-700 hover:text-white transition-colors">
                    Cancel
                </Button>

                <Button loading={isLoading}  className="bg-red-700 text-white border-red-700 hover:bg-red-800 hover:border-red-800 transition-colors" onClick={handleSave}>
                    Save
                </Button>
            </div>
        </div>
    );
};
